import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-new-badge',
  imports: [],
  templateUrl: './new-badge.component.html',
  styleUrl: './new-badge.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NewBadgeComponent {}
